import { Form } from 'antd';
import { memo, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../../../utilz/i18n';
import FormTextArea from '../../../../../../components/Inputs/FormTextArea';
import SecondaryLabel from '../../../../../../components/Labels/SecondaryLabel';

const HallNotesDetails = () => {
  const [form] = Form.useForm();
  const shipmentNote = Form.useWatch('quoteNotes', form);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const { data = {} } = useSelector((state) => state.shipment.shipmentDetails);
  const copyQuoteKey = useSelector((state) => state.common.copyQuoteKey);

  useEffect(() => {
    if (copyQuoteKey) {
      form.setFieldValue('quoteNotes', data?.quoteNotes);
    }
  }, []);

  return (
    <Form name="notesForm" form={form}>
      <FormTextArea
        name="quoteNotes"
        placeholder={`${t('translation:getQuote.notesHere')}...`}
        editMode
        margin="mb-0"
        rows={10}
        maxLength="2000"
        rules={[{ max: 2000, message: 'Note cannot be more than 2000 characters' }]}
        dataTestId="quote-notes-input"
      />
      <SecondaryLabel className="f16" dataTestID="quote-notes-input-char-num">
        {2000 - (shipmentNote ? shipmentNote?.length : 0)} {t('translation:getQuote.characters')}
      </SecondaryLabel>
    </Form>
  );
};

export default memo(HallNotesDetails);
